import { computed as h, toValue as B, watch as S, ref as I, provide as le, inject as W, onMounted as ae, onUnmounted as ne, defineComponent as M, useModel as R, openBlock as g, createBlock as k, unref as a, mergeModels as Y, createElementBlock as F, withCtx as b, renderSlot as v, createTextVNode as V, toDisplayString as y, createCommentVNode as L, normalizeProps as ye, guardReactiveProps as he, withDirectives as Ve, vShow as ge, Fragment as ie, createVNode as z, createElementVNode as oe, normalizeClass as xe } from "vue";
import { useAppI18n as U, useApplicationStore as N, localDate as j, validatePAN as $e, reportCustomError as qe, useFieldStore as ke, reportSessionError as Ce, useAppFieldResponse as re, States as Fe, Countries as Me, formatDate as Te, useSessionStore as Ae, formatCurrency as X } from "@versatile-credit-apply/sdk";
import { useOmniApplyApiClient as K, BadRequestException as Ie, ApplicantType as Ue } from "@versatile-credit-apply/omni-apply-client";
import { createRule as Se, useRegle as we } from "@regle/core";
import { useI18n as D } from "vue-i18n";
import { useValidationRules as De } from "@ui-kit/components";
import { withMessage as w, withAsync as Pe, matchRegex as Ee, minValue as Be, maxValue as Re, withParams as Le, isEmpty as J } from "@regle/rules";
import ze from "@ui-kit/components/input-checkbox";
import Ne from "@ui-kit/components/input-currency";
import O from "@ui-kit/components/input-dropdown";
import Oe from "@ui-kit/components/input-number";
import Ye from "@ui-kit/components/input-postal-code";
import je from "@ui-kit/components/input-ssn";
import Q from "@ui-kit/components/input-text";
import Ke from "@ui-kit/components/input-phone";
import ue from "@ui-kit/components/input-email";
import Ge from "@ui-kit/components/input-date";
import de from "@ui-kit/components/select-button";
import { useOptionalFieldController as Ze } from "@versatile-credit-apply/composition";
import He from "@ui-kit/components/form";
import We from "@ui-kit/components/modal";
import Xe from "primevue/inputnumber";
import Je from "@ui-kit/components/error-text";
const _ = (e, l) => {
  let t = "";
  return e > 0 && (t += "!*".repeat(e)), l > 0 && (t += "#".repeat(l)), t;
}, Qe = (e) => e <= 8 ? "!*!*!*!*-####" : e <= 12 ? "!*!*!*!*-!*!*!*!*-####" : e <= 16 ? "!*!*!*!*-!*!*!*!*-!*!*!*!*-####" : "!*!*!*!*-!*!*!*!*-!*!*!*!*-!*!*!*!*-###", _e = (e, l) => {
  if (e === "all")
    return _(l.length, 0);
  if (e === "last4" && l.length > 4)
    return _(l.length - 4, 4);
  if (e === "pan")
    return Qe(l.length);
}, et = (e, l) => h(() => {
  const t = B(l), n = e.value;
  if (t && typeof n == "string")
    return typeof t == "function" ? t(n) : _e(t, n);
}), tt = (e) => {
  const { t: l, te: t } = U({
    useScope: "parent"
  });
  return h(() => {
    const n = e.value?.id;
    if (t(`appFields.${n}.label`))
      return l(`appFields.${n}.label`);
    const m = `appFields.${e.value?.name}.label`;
    return t(m) ? l(m) : m;
  });
}, lt = (e) => {
  const { t: l, te: t } = U({
    useScope: "parent"
  });
  return h(() => {
    const n = e.value?.name;
    if (t(`appFields.${n}.description`))
      return l(`appFields.${n}.description`);
    const m = `appFields.${e.value?.id}.description`;
    return t(m) ? l(m) : void 0;
  });
}, se = (e) => {
  const l = N(), t = h({
    get() {
      const n = B(e);
      if (n) {
        const o = l.getApplicationValue(n);
        return o === null ? void 0 : o;
      }
    },
    set(n) {
      const o = B(e);
      o && (typeof n == "string" && (n = n.trim()), (n === null || n === "") && (n = void 0), l.setApplicationValue(o, n));
    }
  });
  return S(
    () => B(e),
    (n, o) => {
      o && n && (t.value = l.getApplicationValue(o), l.setApplicationValue(o, void 0));
    }
  ), t;
}, at = (e) => e.rules.some((l) => l.id === "disabled") ? !0 : void 0, nt = (e) => {
  if (e.rules.find(({ id: l }) => l === "required"))
    return !0;
}, it = () => {
  const e = N();
  return (l) => {
    const t = e.getApplicationValue(l.fieldPath);
    switch (l.operation) {
      case "equals":
        return l.fieldValue === t;
      case "not_equals":
        return l.fieldValue !== t;
      case "in":
        return Array.isArray(l.fieldValue) && typeof t == "string" && l.fieldValue.includes(t);
    }
  };
}, ot = (e) => {
  const l = it();
  return h(() => {
    if (!e.value)
      return !1;
    if (nt(e.value))
      return !0;
    const t = e.value.rules.filter(
      ({ id: n }) => n === "requiredIf"
    );
    if (t.length > 0) {
      for (const n of t)
        if (!l(n))
          return;
      return !0;
    }
  });
}, rt = (e) => {
  const l = e.rules.find((t) => t.id === "minLength") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "minLength")
    return l.length;
  if (l?.id === "pan")
    return 8;
}, ut = (e) => {
  const l = e.rules.find((t) => t.id === "maxLength") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "maxLength")
    return l.length;
  if (l?.id === "pan")
    return 19;
}, dt = (e) => {
  const l = e.rules.find((t) => t.id === "validChars") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "validChars") {
    let t = "";
    for (const n of l.validChars)
      n.length === 1 ? t += n.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : t += n;
    return new RegExp(`^[${t}]*$`);
  }
  if (l?.id === "pan")
    return /^\d+$/;
}, st = (e) => {
  const l = e.rules.find(({ id: t }) => t === "min");
  return l?.id === "min" ? l.value : void 0;
}, pt = (e) => {
  const l = e.rules.find(({ id: t }) => t === "max");
  return l?.id === "max" ? l.value : void 0;
}, mt = (e) => {
  const l = e.rules.find(({ id: t }) => t === "maxAge" || t === "minDate");
  if (l?.id === "maxAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - l.age), t;
  }
  if (l?.id === "minDate")
    return j(l.value);
}, ct = (e) => {
  const l = e.rules.find(({ id: t }) => t === "minAge" || t === "maxDate");
  if (l?.id === "minAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - l.age), t;
  }
  if (l?.id === "maxDate")
    return j(l.value);
}, vt = () => {
  const { t: e } = D({ useScope: "global" }), l = K();
  return Se({
    async validator(t) {
      if (t?.length !== 10)
        return !0;
      try {
        return (await l.validatePhone({
          phoneNumber: t
        })).valid;
      } catch {
        return !1;
      }
    },
    message: () => e("validations.phone")
  });
}, bt = (e) => {
  const l = K(), { t } = D({ useScope: "global" });
  return w(
    Pe(async (o, m) => {
      if (m === void 0 || o?.length !== 5 && o?.length !== 9)
        return !0;
      try {
        return {
          $valid: (await l.validateZipCode({
            state: m,
            zipCode: o
          })).valid,
          state: m
        };
      } catch {
        return {
          $valid: !1,
          state: m
        };
      }
    }, [e]),
    ({ state: o }) => t("validations.zipCode", {
      state: o
    })
  );
}, pe = (e, l) => {
  const { t } = D({ useScope: "global" });
  return w(l, () => t(`validations.${e}`));
}, ft = () => pe("pan", (e) => e == null ? !0 : $e(e)), yt = /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|\d*)?\b/i, ht = () => pe("noPoBox", (e) => (e?.length ?? 0) > 0 ? !Ee(e, yt) : !0), Vt = (e) => {
  const l = N();
  return h(() => {
    if (!e.value)
      return;
    const { path: t, type: n } = e.value;
    if (n !== "zip_code" || t.endsWith(".employerZip"))
      return;
    const o = t.replace(".zipCode", ".state");
    return l.getApplicationValue(o);
  });
}, gt = (e, l) => {
  const t = vt(), n = ht(), o = ft(), m = bt(Vt(e));
  De((d) => {
    if (e.value) {
      const { type: c, rules: p } = e.value, x = {
        // @ts-expect-error this really is a thing: https://reglejs.dev/core-concepts/modifiers#per-field-modifiers
        $debounce: 0
      };
      if (l && Object.assign(x, l(d)), c === "phone" && (x.phone = t), c === "zip_code" && (x.zipCode = m), p.length > 0) {
        const f = (u) => p.some(({ id: C }) => C === u);
        f("noPoBox") && (x.noPoBox = n), f("pan") && (x.pan = o);
      }
      return x;
    }
    return {};
  });
}, me = (e, l) => {
  gt(e, l);
  const t = ot(e);
  return h(() => e.value?.rules?.length ? {
    disabled: at(e.value),
    required: t.value,
    minLength: rt(e.value),
    maxLength: ut(e.value),
    minValue: st(e.value),
    maxValue: pt(e.value),
    minDate: mt(e.value),
    maxDate: ct(e.value),
    pattern: dt(e.value)
  } : {});
}, ce = /* @__PURE__ */ Symbol("app-form-state"), ve = /* @__PURE__ */ Symbol("app-form-group-state"), xt = () => {
  const e = I({});
  return le(ce, {
    add(l) {
      e.value[l.id] = l;
    },
    remove(l) {
      delete e.value[l.id];
    }
  }), e;
}, $t = () => {
  const e = I({});
  return le(ve, {
    add(l) {
      e.value[l.id] = l;
    },
    remove(l) {
      delete e.value[l.id];
    }
  }), e;
}, qt = (e) => {
  const l = W(ce, void 0), t = W(ve, void 0);
  S(e, (n, o) => {
    o && (l?.remove(o), t?.remove(o)), n && (l?.add(n), t?.add(n));
  }), ae(() => {
    e.value && (l?.add(e.value), t?.add(e.value));
  }), ne(() => {
    e.value && (l?.remove(e.value), t?.remove(e.value));
  });
}, kt = (e) => qe("validation_error", e.code, e.field), Ct = (e, l, t, n) => {
  const o = n && n.length > 0 ? e.error.fieldErrors.filter((d) => n.includes(d.field)) : e.error.fieldErrors;
  if (o.length === 0)
    return !0;
  const m = {};
  return o.forEach((d) => {
    kt(d);
    const c = d.code.replace("rule.", "");
    m[d.field] = [
      t(`validations.${c}`) ? l(`validations.${c}`, d.params || {}) : d.message
    ];
  }), m;
}, Ft = () => {
  const e = K(), l = N(), t = ke(), { t: n, te: o } = U({
    useScope: "parent"
  });
  return async (m) => {
    const d = t.fieldProviderKeys;
    try {
      return await e.validateApplication({
        providerKeys: d,
        applicationData: l.application ?? {},
        fieldIds: m
      }), !0;
    } catch (c) {
      if (c instanceof Ie)
        return Ct(c, n, o, m);
      throw Ce(c), c;
    }
  };
}, be = /* @__PURE__ */ M({
  __name: "YesNoInput",
  props: /* @__PURE__ */ Y({
    id: {},
    name: {},
    label: {},
    helpText: {},
    required: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const l = R(e, "modelValue"), t = h({
      get() {
        return l.value?.toString();
      },
      set(m) {
        typeof m == "string" ? l.value = m === "true" : l.value = void 0;
      }
    }), { t: n } = D(), o = h(() => [
      {
        value: "true",
        label: n("option.yes.label")
      },
      {
        value: "false",
        label: n("option.no.label")
      }
    ]);
    return (m, d) => (g(), k(a(de), {
      id: e.id,
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (c) => t.value = c),
      name: e.name ?? e.id,
      options: o.value,
      "option-label": (c) => c.label,
      "option-value": (c) => c.value,
      required: e.required,
      label: e.label,
      "help-text": e.helpText
    }, null, 8, ["id", "modelValue", "name", "options", "option-label", "option-value", "required", "label", "help-text"]));
  }
});
function ee(e) {
  const l = e;
  l.__i18n = l.__i18n || [], l.__i18n.push({
    locale: "en",
    resource: {
      option: {
        no: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
        },
        yes: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } }
        }
      }
    }
  });
}
typeof ee == "function" && ee(be);
const Mt = (e) => {
  const l = Ze(), t = h(() => ({
    id: e.value?.id
  }));
  return l?.attach(t.value), S(t, (n, o) => {
    o && l?.detach(o.id), n && l?.attach(n);
  }), ne(() => {
    l?.detach(t.value?.id);
  }), t;
}, Tt = ["id"], At = { key: 14 }, It = {
  boolean: "checkbox",
  cents: "currency",
  country: "dropdown",
  enum: "dropdown",
  email: "email",
  integer: "number",
  list: "dropdown",
  local_date: "date",
  map: void 0,
  months: "number",
  phone: "phone",
  phone_extension: "phone_extension",
  ssn: "ssn",
  state: "dropdown",
  text: "text",
  years: "number",
  yesNo: "yes-no",
  zip_code: "zip"
}, nl = /* @__PURE__ */ M({
  __name: "AppField",
  props: /* @__PURE__ */ Y({
    label: {},
    helpText: {},
    path: {},
    pathPrefix: {},
    preferredComponent: {},
    required: { type: Boolean },
    disabled: { type: Boolean },
    inputMask: {},
    privacyMode: { type: [String, Function] },
    optionDisabled: { type: Function },
    displayUnit: {}
  }, {
    visible: { type: Boolean },
    visibleModifiers: {},
    modelValue: {
      // Value passed here comes from the parent component's v-model binding
    },
    modelModifiers: {}
  }),
  emits: ["update:visible", "update:modelValue"],
  setup(e) {
    const l = e, t = re(
      () => l.pathPrefix ? `${l.pathPrefix}.${l.path}` : l.path
    ), n = R(e, "visible"), o = se(() => t.value?.path), m = I(!0), d = R(e, "modelValue", {
      // Value passed here comes from the parent component's v-model binding
      get(i) {
        const r = o.value;
        return m.value && r != null && i == null ? d.value = r : r !== i && (o.value = i), m.value = !1, o.value;
      },
      set(i) {
        return o.value !== i && (o.value = i), o.value;
      }
    }), c = tt(t), p = h(() => l.label ?? c.value), x = lt(t), f = h(() => l.helpText ?? x.value), u = me(t), C = U({ useScope: "parent" });
    qt(t), Mt(t);
    const q = h(() => {
      if (!t.value?.type)
        return;
      const r = l.preferredComponent ?? It[t.value.type];
      return r === "dropdown" && l.preferredComponent !== "dropdown" && T.value.length < 4 ? "selectbutton" : r;
    }), T = h(() => {
      if (t.value?.type === "state" && !t.value?.rules.find(({ id: r }) => r === "validOptions"))
        return Fe.map((r) => ({
          value: r.id,
          label: r.name
        }));
      if (t.value?.type === "country")
        return Me.map((r) => ({
          value: r.id,
          label: r.name
        }));
      const i = t.value?.rules?.find(({ id: r }) => r === "validOptions");
      return i?.id === "validOptions" ? i.options.sort((r, s) => r.order - s.order).map((r) => ({
        value: r.value,
        label: C.te(
          `appFields.${t.value?.id}.option.${r.value}.label`
        ) ? C.t(
          `appFields.${t.value?.id}.option.${r.value}.label`
        ) : r.label
      })) : [];
    }), $ = h({
      get() {
        const i = d.value;
        return typeof i == "string" ? i : void 0;
      },
      set(i) {
        d.value = i;
      }
    }), P = h({
      get() {
        const i = d.value;
        return typeof i == "number" ? i : void 0;
      },
      set(i) {
        d.value = i;
      }
    }), A = h({
      get() {
        const i = d.value;
        return typeof i == "number" || typeof i == "string" ? i : void 0;
      },
      set(i) {
        d.value = i;
      }
    }), E = h({
      get() {
        const i = d.value;
        return typeof i == "boolean" ? i : void 0;
      },
      set(i) {
        d.value = i;
      }
    }), G = h({
      get() {
        const i = d.value;
        return typeof i == "string" ? j(i) : void 0;
      },
      set(i) {
        i != null ? d.value = Te(i, "isoDate") : d.value = void 0;
      }
    }), Z = h(
      () => t.value?.rules?.find((i) => i.id === "pan") != null
    ), fe = h(() => {
      if (l.inputMask)
        return l.inputMask;
      if (Z.value)
        return "####-####-####-####-###";
    }), H = et(d, () => {
      if (l.privacyMode)
        return l.privacyMode;
      if (Z.value)
        return "pan";
    });
    return S(
      t,
      (i) => {
        n.value = !!i;
      },
      {
        immediate: !0
      }
    ), S(o, (i) => {
      d.value !== i && (d.value = i);
    }), (i, r) => a(t) ? (g(), F("div", {
      key: 0,
      id: `app-field--${a(t).id}`,
      class: "relative"
    }, [
      q.value === "text" ? (g(), k(a(Q), {
        key: 0,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        "min-length": a(u).minLength,
        "max-length": a(u).maxLength,
        pattern: a(u).pattern,
        disabled: e.disabled || a(u).disabled,
        "privacy-mask": a(H),
        mask: fe.value
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-length", "max-length", "pattern", "disabled", "privacy-mask", "mask"])) : q.value === "ssn" ? (g(), k(a(je), {
        key: 1,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[1] || (r[1] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : q.value === "number" ? (g(), k(a(Oe), {
        key: 2,
        id: a(t).id,
        modelValue: P.value,
        "onUpdate:modelValue": r[2] || (r[2] = (s) => P.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        "min-value": a(u).minValue,
        "max-value": a(u).maxValue,
        "max-length": a(u).maxLength,
        disabled: e.disabled || a(u).disabled,
        type: "integer",
        "privacy-mask": a(H)
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-value", "max-value", "max-length", "disabled", "privacy-mask"])) : q.value === "currency" ? (g(), k(a(Ne), {
        key: 3,
        id: a(t).id,
        modelValue: P.value,
        "onUpdate:modelValue": r[3] || (r[3] = (s) => P.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        "min-amount-cents": a(u).minValue,
        "max-amount-cents": a(u).maxValue,
        disabled: e.disabled || a(u).disabled,
        "model-unit": "cents",
        "display-unit": e.displayUnit ?? "dollars"
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-amount-cents", "max-amount-cents", "disabled", "display-unit"])) : q.value === "dropdown" ? (g(), k(a(O), {
        key: 4,
        id: a(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[4] || (r[4] = (s) => A.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        options: T.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": a(u).required === void 0,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled"])) : q.value === "selectbutton" ? (g(), k(a(de), {
        key: 5,
        id: a(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[5] || (r[5] = (s) => A.value = s),
        options: T.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled,
        label: p.value,
        "help-text": f.value
      }, null, 8, ["id", "modelValue", "options", "option-label", "option-value", "option-disabled", "required", "disabled", "label", "help-text"])) : q.value === "zip" ? (g(), k(a(Ye), {
        key: 6,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[6] || (r[6] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : q.value === "email" ? (g(), k(a(ue), {
        key: 7,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[7] || (r[7] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        "min-length": a(u).minLength,
        "max-length": a(u).maxLength,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-length", "max-length", "disabled"])) : q.value === "phone" ? (g(), k(a(Ke), {
        key: 8,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[8] || (r[8] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : q.value === "date" ? (g(), k(a(Ge), {
        key: 9,
        id: a(t).id,
        modelValue: G.value,
        "onUpdate:modelValue": r[9] || (r[9] = (s) => G.value = s),
        required: e.required || a(u).required,
        "min-date": a(u).minDate,
        "max-date": a(u).maxDate,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "required", "min-date", "max-date", "disabled"])) : q.value === "checkbox" ? (g(), k(a(ze), {
        key: 10,
        id: a(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": r[10] || (r[10] = (s) => E.value = s),
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "required", "disabled"])) : q.value === "yes-no" ? (g(), k(be, {
        key: 11,
        id: a(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": r[11] || (r[11] = (s) => E.value = s),
        name: a(t).id,
        label: p.value,
        "help-text": f.value,
        required: e.required || a(u).required,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "label", "help-text", "required", "disabled"])) : q.value === "phone_extension" ? (g(), k(a(Q), {
        key: 12,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[12] || (r[12] = (s) => $.value = s),
        type: "tel",
        name: a(t).id,
        required: e.required || a(u).required,
        "min-length": 3,
        "max-length": 6,
        pattern: /\d{3,6}/,
        disabled: e.disabled || a(u).disabled
      }, {
        label: b(() => [
          v(i.$slots, "label", {}, () => [
            V(y(p.value), 1)
          ])
        ]),
        helpText: b(() => [
          v(i.$slots, "helpText", {}, () => [
            V(y(f.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : q.value === "country" ? (g(), k(a(O), {
        key: 13,
        id: a(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[13] || (r[13] = (s) => A.value = s),
        name: a(t).id,
        required: e.required || a(u).required,
        options: T.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": a(u).required === void 0,
        disabled: e.disabled || a(u).disabled
      }, null, 8, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled"])) : (g(), F("span", At, "Not implemented: " + y(a(t).type), 1)),
      v(i.$slots, "description")
    ], 8, Tt)) : L("", !0);
  }
}), il = /* @__PURE__ */ M({
  __name: "AppForm",
  props: {
    id: {},
    submitting: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["submit"],
  setup(e, { emit: l }) {
    const t = l, n = I(!1), o = xt(), m = Ft(), d = async () => {
      n.value = !0;
      const c = Object.keys(o.value), p = await m(c);
      return n.value = !1, p;
    };
    return (c, p) => (g(), k(a(He), {
      id: e.id,
      disabled: e.disabled || n.value,
      submitting: e.submitting || n.value,
      "before-submit": d,
      class: "flex h-full flex-col",
      onSubmit: p[0] || (p[0] = (x) => t("submit"))
    }, {
      default: b((x) => [
        v(c.$slots, "default", ye(he(x)))
      ]),
      _: 3
    }, 8, ["id", "disabled", "submitting"]));
  }
}), ol = /* @__PURE__ */ M({
  __name: "AppFormGroup",
  setup(e) {
    const l = $t(), t = h(() => Object.keys(l.value).length > 0);
    return (n, o) => Ve((g(), F("div", null, [
      v(n.$slots, "default")
    ], 512)), [
      [ge, t.value]
    ]);
  }
}), Ut = /* @__PURE__ */ M({
  __name: "TestCaseChooser",
  emits: ["selected"],
  setup(e, { emit: l }) {
    const t = Ae(), { t: n } = U(), o = I(t.testCase?.id), m = I(!1), d = h(() => (t.testCases.length ?? 0) > 0), c = l, p = () => {
      d.value && (m.value = !0);
    }, x = () => {
      const u = o.value, C = u != null ? t.testCases.find((q) => q.id === u) : void 0;
      C && c("selected", C);
    }, f = () => {
      o.value = void 0;
    };
    return (u, C) => {
      const q = O, T = We;
      return g(), F(ie, null, [
        z(T, {
          modelValue: m.value,
          "onUpdate:modelValue": C[1] || (C[1] = ($) => m.value = $),
          header: "Test Case",
          "cancel-button-label": a(n)("buttons.cancel"),
          "accept-button-label": a(n)("buttons.accept"),
          onModalAccept: x,
          onModalReject: f
        }, {
          default: b(() => [
            z(q, {
              id: "testCases",
              modelValue: o.value,
              "onUpdate:modelValue": C[0] || (C[0] = ($) => o.value = $),
              options: a(t).testCases,
              "option-label": ($) => $.name,
              "option-value": ($) => $.id
            }, null, 8, ["modelValue", "options", "option-label", "option-value"])
          ]),
          _: 1
        }, 8, ["modelValue", "cancel-button-label", "accept-button-label"]),
        oe("div", {
          class: xe({
            "cursor-pointer": d.value
          }),
          onClickCapture: p
        }, [
          v(u.$slots, "default")
        ], 34)
      ], 64);
    };
  }
});
function te(e) {
  const l = e;
  l.__i18n = l.__i18n || [], l.__i18n.push({
    locale: "en",
    resource: {
      buttons: {
        accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } },
        cancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } }
      }
    }
  });
}
typeof te == "function" && te(Ut);
const St = { class: "flex flex-col gap-2 lg:w-90" }, wt = ["for"], Dt = { key: 0 }, rl = /* @__PURE__ */ M({
  __name: "BoringPaymentCalculatorInput",
  props: /* @__PURE__ */ Y({
    id: {},
    currencyMode: { default: "dollars" },
    minValue: { default: void 0 },
    maxValue: { default: void 0 },
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const l = R(e, "modelValue"), t = e, n = h({
      get() {
        if (l.value != null)
          return t.currencyMode === "cents" ? l.value / 100 : l.value;
      },
      set(p) {
        if (p == null) {
          l.value = void 0;
          return;
        }
        t.currencyMode === "cents" ? l.value = p * 100 : l.value = p;
      }
    }), { t: o, te: m } = U({
      useScope: "parent"
    }), d = (p) => m(`validations.${t.id}.${p}`) ? `validations.${t.id}.${p}` : `validations.${p}`, { r$: c } = we(l, () => ({
      maxValue: w(
        Re(() => t.maxValue),
        () => o(d("maxValue"), {
          max: X(t.maxValue, t.currencyMode)
        })
      ),
      minValue: w(
        Be(() => t.minValue),
        () => o(d("minValue"), {
          min: X(t.minValue, t.currencyMode)
        })
      )
    }));
    return ae(() => c.$touch()), (p, x) => (g(), F(ie, null, [
      oe("div", St, [
        p.$slots.label ? (g(), F("label", {
          key: 0,
          for: e.id,
          class: "text-sm text-surface-600"
        }, [
          v(p.$slots, "label")
        ], 8, wt)) : L("", !0),
        z(a(Xe), {
          modelValue: n.value,
          "onUpdate:modelValue": x[0] || (x[0] = (f) => n.value = f),
          "input-id": e.id,
          invalid: a(c).$invalid,
          disabled: e.disabled,
          "input-class": [
            "text-center !text-xl font-semibold",
            {
              "!text-primary-600 ": !a(c).$invalid,
              "!text-danger-600": a(c).$invalid
            }
          ],
          currency: "USD",
          mode: "currency"
        }, null, 8, ["modelValue", "input-id", "invalid", "disabled", "input-class"])
      ]),
      a(c).$errors.length ? (g(), F("p", Dt, [
        z(a(Je), {
          class: "relative!",
          for: e.id,
          "active-error": a(c).$errors[0]
        }, null, 8, ["for", "active-error"])
      ])) : L("", !0)
    ], 64));
  }
}), ul = /* @__PURE__ */ M({
  __name: "ConfirmEmailField",
  props: {
    applicantType: { default: Ue.PRIMARY },
    id: { default: void 0 }
  },
  setup(e) {
    const l = e, t = se(() => `${l.applicantType}.email`), n = re(
      () => `${l.applicantType}.email`
    ), o = (x) => `validations.${x}`, { t: m } = D({
      useScope: "parent"
    }), d = h(() => n.value ? {
      ...n.value,
      id: `${l.applicantType}ConfirmEmail`,
      name: `${l.applicantType}ConfirmEmail`
    } : null), c = w(
      Le(
        (x, f) => J(x) || J(f) ? !0 : x === f,
        [t]
      ),
      () => m(o("emailMatch"))
    ), p = me(
      d,
      () => ({ emailMatch: c })
    );
    return (x, f) => {
      const u = ue;
      return d.value ? (g(), k(u, {
        key: 0,
        id: d.value.id,
        label: a(m)("appFields.confirmEmail.label"),
        required: a(p).required,
        "min-length": a(p).minLength,
        "max-length": a(p).maxLength,
        disabled: a(p).disabled,
        class: "w-full"
      }, null, 8, ["id", "label", "required", "min-length", "max-length", "disabled"])) : L("", !0);
    };
  }
});
export {
  nl as _,
  vt as a,
  il as b,
  ol as c,
  rl as d,
  ul as e,
  Ut as f,
  se as u
};
//# sourceMappingURL=index-DpoTJ7ct.js.map
